import axios from "axios";
import * as dotenv from "dotenv";
dotenv.config();
const instance_axios = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
});
let headers = new Headers();
headers.append("Content-Type", "application/json");
headers.append("Accept", "application/json");

/**
 * Fields of the user document that can be edited from the Profile modal.
 */
export const PROFILE_FIELDS = [
    "first_name",
    "last_name",
    "publisher_id",
    "phone_number",
    "email",
];

/**
 * Get the user document of the logged user.
 * Endpoint /user/
 * @returns The Promise that resolves the response, its data is the user document
 */
export const getUser = () => {
    return instance_axios
        .get("/user/", {
            withCredentials: true,
            headers: { common: headers },
        })
        .then((user) => user)
        .catch((err) => err.request);
};
export const postUser = (user) => {
    return instance_axios
        .post("/generic", user, {
            withCredentials: true,
            headers: { common: headers },
        })
        .then((res) => res)
        .catch((err) => err.request);
};

/**
 * Build the user document to save from the stored user and the values of the form.
 * A non empty value replaces the field, an empty value keeps the stored one.
 * Every other field of the stored user (_id, _rev, type, password...) is kept.
 * @param {{}} storedUser The user document as returned by getUser
 * @param {{}} formValues Values of the form, keyed by PROFILE_FIELDS
 * @returns {{}} A new user document
 */
export const buildUserToSave = (storedUser = {}, formValues = {}) => {
    let user = { ...storedUser };
    PROFILE_FIELDS.forEach((field) => {
        let value = formValues[field];
        if (
            value !== undefined &&
            value !== null &&
            String(value).trim() !== ""
        ) {
            user[field] = value;
        }
    });
    return user;
};

/**
 * Get the new revision of the user from the response of postUser.
 * The endpoint answers 201 with the result of each document, so a conflict also comes with status 201.
 * @param {{}} response The response of postUser
 * @returns {String|null} The new _rev if the user was saved, null otherwise
 */
export const getRevFromSaveResponse = (response) => {
    if (response?.status !== 201 || !Array.isArray(response.data)) {
        return null;
    }
    let result = response.data[0];
    if (!result || result.ok !== true || !result.rev) {
        return null;
    }
    return result.rev;
};

export const changePassword = (newPassword, oldPassword, userID) => {
    return instance_axios
        .post(
            "/user/changepassword",
            { newPassword, oldPassword, userID },
            {
                withCredentials: true,
                headers: { common: headers },
            },
        )
        .then((res) => res)
        .catch((err) => err.request);
};
